import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  data: undefined as Record<string, any> | null | undefined,
  error: null,
};

export const projectRetainerSlice = createSlice({
  name: 'projectRetainer',
  initialState,
  reducers: {
    getProjectRetainer: () => {},
    setProjectRetainerLoading: (state) => ({ ...state, loading: true }),
    setProjectRetainerData: (state, action) => ({
      ...state,
      loading: false,
      data: action.payload,
    }),
    clearProjectRetainerData: () => initialState,
    setProjectRetainerError: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload,
    }),
    setProjectRetainerBudget: (state, action) => {
      if (state.data?.budget) {
        state.data.budget.total += action.payload;
        if (state.data.budget.bar?.available) {
          state.data.budget.bar.available.value += action.payload;
        }
      }
    },
    setOnboardingStep: (state, action) => {
      if (!state.data?.customer) return state;
      return {
        ...state,
        data: {
          ...state.data,
          customer: {
            ...state.data.customer,
            onboarding_step: action.payload,
          },
        },
      };
    },
  },
});

export const {
  setProjectRetainerData,
  setProjectRetainerError,
  setProjectRetainerLoading,
  getProjectRetainer,
  clearProjectRetainerData,
  setOnboardingStep,
  setProjectRetainerBudget,
} = projectRetainerSlice.actions;

export default projectRetainerSlice.reducer;
